'use strict';

/**
 * @ngdoc function
 * @name thothApp.services:ScopeChangeReview
 * @description
 * # ScopeChangeReview
 * Aprobar y rechazar solicitudes de cambio de alcance. Lo usan la bandeja y el
 * detalle, por eso vive aparte de los controladores.
 */
angular.module('thothApp.services')
  .factory('ScopeChangeReview', ['$q', '$mdDialog', 'ScopeChangeRequest', 'Project', 'GoogleApi',
  function ($q, $mdDialog, ScopeChangeRequest, Project, GoogleApi) {

    // El servidor crea el proyecto dentro de la carpeta de proyectos del
    // cliente. Aqui se le crea su carpeta propia y se guarda la definitiva,
    // igual que al dar de alta un proyecto normal.
    function createProjectFolders(reviewed) {
      if (!reviewed || !reviewed.generated_project_id) {
        return $q.resolve();
      }

      return Project.find(reviewed.generated_project_id).then(function(response) {
        var project = response.data.project;
        var folderName = project.project_code + '_' + project.name;

        // El servidor dejo el proyecto apuntando a la carpeta de proyectos del
        // cliente; ahi es donde va la carpeta propia.
        return GoogleApi.createProjectFolderStructure(folderName, project.project_code, project.drive_root_id)
          .then(function(created) {
            return Project.save({
              project: {
                id: project.id,
                drive_root_id: created.id,
                drive_root_url: created.url,
                audit_comment: 'Carpetas creadas para el cambio de alcance'
              }
            });
          })
          .catch(function() {
            return $q.reject('El proyecto se creó, pero no se pudieron generar sus carpetas en Drive. Revisa tu sesión de Google y avisa a soporte.');
          });
      });
    }

    return {
      approve: function(request) {
        var confirm = $mdDialog.confirm()
          .title('Aprobar cambio de alcance')
          .textContent('Se aprobará la solicitud "' + request.name + '" y se creará el proyecto.')
          .ok('Aprobar')
          .cancel('Cancelar');

        return $mdDialog.show(confirm).then(function() {
          return ScopeChangeRequest.approve(request.id).then(function(response) {
            return createProjectFolders(response.data.scope_change_request)
              .then(function() { return response.data.scope_change_request; });
          });
        });
      },

      reject: function(request) {
        var prompt = $mdDialog.prompt()
          .title('Rechazar cambio de alcance')
          .textContent('Indique el motivo del rechazo de "' + request.name + '".')
          .placeholder('Motivo')
          .required(true)
          .ok('Rechazar')
          .cancel('Cancelar');

        return $mdDialog.show(prompt).then(function(comment) {
          return ScopeChangeRequest.reject(request.id, comment).then(function(response) {
            return response.data.scope_change_request;
          });
        });
      },

      // Los errores de Drive llegan como texto; los del API como objeto. Cancelar
      // el dialogo rechaza sin error y no se reporta.
      report: function(error, toaster) {
        if (!error) {
          return;
        }

        if (typeof error === 'string') {
          toaster.pop('error', 'Google Drive', error);
        } else if (error.data) {
          ScopeChangeRequest.error(error);
        } else {
          toaster.pop('error', 'Cambio de alcance', error.message || 'Ocurrió un error inesperado.');
        }
      }
    };
  }]);
